import camelCase from 'lodash.camelcase';
import { useMemo } from 'react';


export function useInput(
  defaultId?:string,
  label? :string,
  icon?: any
) {
  const id = useMemo(
    () => defaultId || camelCase(`input ${label}`),
    [defaultId, label]
  );
  const {
    idIcon,
    idFeedback,
    ariaDescribedby
  } = useMemo(() => {
    const idIconCalculated = icon ? `${id}Icon` : '';
    const idFeedbackCalculated = `${id}Feedback`;
    const ariaDescribedbyCalculated = `${idIconCalculated} ${idFeedbackCalculated}`.trim();
    return {
      idIcon: idIconCalculated,
      idFeedback: idFeedbackCalculated,
      ariaDescribedby: ariaDescribedbyCalculated
    };
  }, [icon, id]);

  return {
    id,
    idIcon,
    idFeedback,
    ariaDescribedby
  };
}

export default useInput;
